import {
  Typography,
  List,
  ListItem,
  FormControlLabel,
  Checkbox,
  withStyles,
  makeStyles
} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    width: '304px',
    height: '230px'
  },
  listInformation: {
    width: '100',
    maxWidth: 375,
    borderRadius: 8,
    maxHeight: 469,
    backgroundColor: theme.palette.background.paper
  },
  popoverHeader: {
    textAlign: 'left'
  }
}));

const TableSetting = ({ showColumns, handleClose, handleShowColumns }) => {
  const classes = useStyles();
  const { gpsSpeedCol, speedCol, engineStatusCol, latLngCol } = showColumns;
  return (
    <>
      <Typography className={classes.typography}>
        <div className={classes.popoverHeader}>
          <b> Cài đặt hiển thị </b>
          <span className="float-right">
            <img
              className="list_tracking_action"
              onClick={handleClose}
              alt="icon"
              width="12px"
              height="12px"
              src="/static/iconSvg/close-btn.svg"
            />
          </span>
        </div>
        <List className={classes.listInformation}>
          <ListItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={gpsSpeedCol}
                  onChange={handleShowColumns}
                  name="gpsSpeedCol"
                  color="primary"
                />
              }
              label="Hiển thị vận tốc GPS"
            />
          </ListItem>
          <ListItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={speedCol}
                  onChange={handleShowColumns}
                  name="speedCol"
                  color="primary"
                />
              }
              label="Hiển thị vận tốc cơ"
            />
          </ListItem>
          <ListItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={engineStatusCol}
                  onChange={handleShowColumns}
                  name="engineStatusCol"
                  color="primary"
                />
              }
              label="Hiển thị trạng thái động cơ"
            />
          </ListItem>
        </List>
      </Typography>
    </>
  );
};

export default React.memo(TableSetting);
